import { useContext } from "react";

import { footerProvider } from "./FooterProvider";
import type { FooterTranslations } from "./FooterTranslationProvider";

export const useFooterTranslations = (): FooterTranslations => {
  const data = useContext(footerProvider);
  if (!data) {
    throw new Error(
      "Footer translations can't be null, please add footerProvider",
    );
  }

  return data;
};
